import React from 'react'
import AboutBlack from './AboutBlack';
import HeaderBlack from '../component/Header/HeaderBlack';
import Footer from '../component/Header/Footer';
function MainBiolyBlak()
{

return(
    <>
<HeaderBlack/>
<section id="app-clasic-faq-main-section">
    <div className="container">
        <div className="app-clasic-faq-text">
             <h1>FAQ</h1>
             <p><span>Home</span> / FAQ</p>
        </div>
    </div>
</section>
<AboutBlack/>
<Footer/>
</>
);
}
export default MainBiolyBlak;